
const CalculatedDiscountAllocation = {
  "name": "CalculatedDiscountAllocation",
  "kind": "OBJECT",
  "fieldBaseTypes": {
    "allocatedAmountSet": "MoneyBag",
    "discountApplication": "CalculatedDiscountApplication"
  },
  "implementsNode": false
};
export default CalculatedDiscountAllocation;